<template>
  <div class="w-full bg-white height-100">
    <el-dialog title="" :visible.sync="dialogVisible" width="55%">
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">Variables</h3></template
      >
      <div><Table /></div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
              class="flex"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create an Whatsapp Template
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white menucontrol-scroll fixed-top py-6 px-20">
      <div class="flex justify-around gap-4">
        <div class="w-3/5 flex justify-start">
          <div class="flex items-center justify-end">
            <p class="col-4f text-xl cross mb-0 whitenowrap font-semibold">
              Preview
            </p>
          </div>
          <div class="w-3/4">
            <div class="relative">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/whatsapp.svg"
                alt="sms"
                class="width-whatsapp"
              />
              <div
                class="absolute top-0 left-0 right-0 width-whatsapps flex justify-center items-end"
              >
                <div class="rounded-12px pr-16 pl-12">
                  <div>
                    <div class="text-center">
                      <small class="text-646464">{{ dateFormat }}</small>
                    </div>
                    <!-- This is Image View -->
                    <div
                      v-if="value1 == 'Image'"
                      class="mt-4 w-full rounded-10px bg-white py-4 mr-5 pl-3 pr-2"
                    >
                      <div>
                        <img
                          :src="
                            this.image1Source
                              ? image1Source
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        />
                        <p
                          v-if="smsbody"
                          class="text-black fsize12"
                          v-html="smsbody"
                        ></p>

                        <p v-if="!smsbody" class="text-black fsize12">
                          Note:You can use dynamic tags to fetch info like
                          names,companies & contact info.
                          <a href="https://projectbrained.app/asjahfo.in"
                            >https://projectbrained.app/asjahfo</a
                          >
                        </p>
                      </div>
                      <div class="text-right">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                    </div>

                    <!-- This is Video View -->
                    <div
                      v-if="value1 == 'Video'"
                      class="mt-4 w-full rounded-10px bg-white py-4 mr-5 pl-3 pr-2"
                    >
                      <div>
                        <video
                          :src="
                            this.image1Source
                              ? image1Source
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        ></video>
                        <p
                          v-if="smsbody"
                          class="text-black fsize12"
                          v-html="smsbody"
                        ></p>
                        <p v-if="!smsbody" class="text-black fsize12">
                          Note:You can use dynamic tags to fetch info like
                          names,companies & contact info.
                          <a href="https://projectbrained.app/asjahfo.in"
                            >https://projectbrained.app/asjahfo</a
                          >
                        </p>
                      </div>
                      <div class="text-right">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                    </div>
                    <!-- This is File view -->
                    <div
                      v-if="value1 == 'File'"
                      class="mt-4 w-full rounded-10px bg-white py-4 mr-5 pl-3 pr-2"
                    >
                      <div>
                        <iframe
                          :src="
                            this.image1Source
                              ? image1Source
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        ></iframe>
                        <p
                          v-if="smsbody"
                          class="text-black fsize12"
                          v-html="smsbody"
                        ></p>
                        <p v-if="!smsbody" class="text-black fsize12">
                          Note:You can use dynamic tags to fetch info like
                          names,companies & contact info.
                          <a href="https://projectbrained.app/asjahfo.in"
                            >https://projectbrained.app/asjahfo</a
                          >
                        </p>
                      </div>
                      <div class="text-right">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                    </div>
                    <!-- This is Default View -->
                    <div
                      v-if="value1 == 'Text'"
                      class="mt-4 w-full rounded-10px bg-white py-2 mr-5 px-2"
                    >
                      <div>
                        <!-- <img
                          src="@/assets/images/Default-img.png"
                          class="w-full h-110px object-cover"
                          alt="image"
                        /> -->
                        <div>
                          <div v-if="smsbody">
                            <p class="text-black fsize12" v-html="smsbody"></p>
                          </div>
                          <div v-else>
                            <p class="text-black fsize12">
                              Note:You can use dynamic tags to fetch info like
                              names,companies & contact info.
                              <a href="https://projectbrained.app/asjahfo.in"
                                >https://projectbrained.app/asjahfo</a
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="text-right">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                    </div>
                    <div
                      v-if="value1 == 'Variable'"
                      class="mt-4 w-full rounded-10px bg-white py-2 mr-5 px-2"
                    >
                      <div>
                        <div>
                          <div v-if="variable || variableHeaderValue">
                            <p
                              v-if="count"
                              class="text-black fsize12"
                              v-html="
                                headerDefaultPreviewStructure
                                  ? headerDefaultPreviewStructure
                                  : variableHeaderValue
                              "
                            ></p>
                            <p
                              v-if="!count"
                              class="text-black fsize12"
                              v-html="variable ? variable : variableHeaderValue"
                            ></p>
                          </div>
                          <div v-if="variableSmsBody">
                            <p
                              class="text-black fsize12"
                              v-html="formattedText(defaultPreviewStructure)"
                            ></p>
                            <!-- <p
                              class="text-black fsize12"
                              v-html="formattedText(variableSmsBody)"
                            ></p> -->
                          </div>
                          <div v-else>
                            <p class="text-black fsize12">
                              Note:You can use dynamic tags to fetch info like
                              names,companies & contact info.
                              <a href="https://projectbrained.app/asjahfo.in"
                                >https://projectbrained.app/asjahfo</a
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="text-right">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                    </div>
                    <!-- This is Interactive View -->
                    <div
                      v-if="value1 == 'Interactive'"
                      class="mt-4 w-full rounded-10px bg-white py-2 mr-5 px-2"
                    >
                      <div>
                        <div>
                          <div v-if="headerBody">
                            <p
                              class="text-black fsize12"
                              v-html="headerBody"
                            ></p>
                          </div>
                          <div v-if="smsbody">
                            <p class="text-black fsize12" v-html="smsbody"></p>
                          </div>
                          <div v-if="footerBody">
                            <p
                              class="text-black fsize12"
                              v-html="footerBody"
                            ></p>
                          </div>
                          <div v-else>
                            <p class="text-black fsize12">
                              Note:You can use dynamic tags to fetch info like
                              names,companies & contact info.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="text-right">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                    </div>
                    <div
                      v-if="value1 == 'Interactive'"
                      class="w-full rounded-10px bg-white"
                    >
                      <div v-if="buttonOptions != 'None'">
                        <p
                          v-if="buttonOptionsArray[0]"
                          class="text-blue fsize12 text-center"
                        >
                          {{
                            buttonOptionsArray[0].buttonTitle
                              ? buttonOptionsArray[0].buttonTitle
                              : "Give A Button Title"
                          }}
                        </p>
                        <p
                          v-if="buttonOptionsArray[1]"
                          class="text-blue fsize12 text-center"
                        >
                          {{
                            buttonOptionsArray[1].buttonTitle
                              ? buttonOptionsArray[1].buttonTitle
                              : "Give A Button Title"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="fsize12 col-4f mt-4">
              Note: The appearence of the text message may vary <br />based on
              the style preference on diffrent device.
            </p>
          </div>
        </div>
        <div
          class="bg-white w-2/5 cust-shadow rounded-10px pl-8 pr-4 pt-8 pb-4 relative"
        >
          <div v-if="!isshowform" class="cust-scroll-wh pr-4">
            <!-- <div>
              <h6 class="col-4f text-xl mb-2">Template Type</h6>
              <el-radio v-model="radio" label="1">Text</el-radio>
              <el-radio v-model="radio" label="2">Media</el-radio>
              
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ templateName === "" ? "This Field is required" : "" }}
              </p>
            </div> -->
            <div>
              <h6 class="col-4f text-xl mb-0 font-semibold">Template name*</h6>
              <p class="pt-2 text-gray">Give your message template a name.</p>
              <el-input
                placeholder="Enter..."
                class="mt-2 w-full"
                v-model="templateName"
              ></el-input>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ templateName === "" ? "This Field is required" : "" }}
              </p>
              <p class="text-gray pt-1 fsize12">
                Template names can only contain small letters, numbers and
                underscores.
              </p>
            </div>

            <div class="mt-6">
              <h6 class="col-4f text-xl mb-0">Language*</h6>
              <p class="pt-2 text-gray">
                Choose which languages your message template will be sent in.
              </p>

              <el-select
                v-model="value"
                placeholder="Select"
                class="w-full mt-2"
              >
                <el-option
                  v-for="item in templateTypeOptions"
                  :key="item.text"
                  :label="item.text"
                  :value="item.text"
                >
                </el-option>
              </el-select>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ value === "" ? "This Field is required" : "" }}
              </p>
            </div>

            <div class="mt-6">
              <h6 class="col-4f text-xl mb-0">Media Type*</h6>
              <p class="pt-2 text-gray">Select the type of media</p>
              <el-select
                v-model="value1"
                placeholder="Select"
                class="w-full mt-2"
              >
                <el-option
                  v-for="item in MediaTypeOptions"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ templateName === "" ? "This Field is required" : "" }}
              </p>
            </div>

            <!-- <div v-if="value1 == 'Interactive'" class="mt-6">
              <h6 class="col-4f text-xl mb-0">Footer</h6>
              <p class="pt-2 text-gray">
                Add a 60 character footer to your message. Variables are not
                supported in the footer.
              </p>
              <el-input
                placeholder="Enter..."
                class="mt-2 w-full"
                v-model="footerName"
              ></el-input>

              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ templateName === "" ? "This Field is required" : "" }}
              </p>
              <p class="text-gray pt-1 fsize12">Characters: 13 / 60</p>
            </div> -->

            <div v-if="value1 == 'Interactive'" class="mt-6">
              <h6 class="col-4f text-xl mb-0">Buttons</h6>

              <el-select
                v-model="buttonselect"
                placeholder="Select"
                class="w-full mt-2"
              >
                <el-option
                  v-for="option in buttonOptions"
                  :key="option.value"
                  :label="option.value"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- button -->
            <div v-if="buttonselect == 'Call to action'">
              <div class="mt-6">
                <div
                  v-for="button in buttonOptionsArray"
                  :key="button"
                  class="flex gap-4"
                >
                  <div class="w-1/3">
                    <h6 class="col-4f text-md mb-0">Select type</h6>

                    <el-select
                      v-model="button.typeValue"
                      placeholder="Select"
                      class="w-full mt-2"
                    >
                      <el-option
                        v-for="typeOptions in selecttypeOptions"
                        :key="typeOptions.value"
                        :label="typeOptions.label"
                        :value="typeOptions.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="w-1/3">
                    <h6 class="col-4f text-md mb-0">Button Title</h6>

                    <el-input
                      placeholder="Enter..."
                      class="mt-2 w-full"
                      v-model="button.buttonTitle"
                    ></el-input>
                  </div>
                  <div class="w-1/3">
                    <h6 class="col-4f text-md mb-0">Button Value</h6>

                    <el-input
                      placeholder="Enter..."
                      class="mt-2 w-full"
                      v-model="button.buttonValue"
                    ></el-input>
                  </div>
                </div>

                <div class="flex gap-4 mt-4">
                  <vs-button
                    v-if="removeCountVerf()"
                    @click="remove()"
                    type="border"
                    size="small"
                    color="primary"
                    >Remove</vs-button
                  >
                  <vs-button
                    v-if="addCountVerf()"
                    @click="add()"
                    color="primary"
                    size="small"
                    >Add</vs-button
                  >
                </div>
              </div>
            </div>

            <div v-if="buttonselect == 'Quick reply'" class="mt-6">
              <h6 class="col-4f text-xl mb-0">Quick Reply Title</h6>
              <div class="flex pt-2">
                <el-input
                  placeholder="Enter..."
                  class="mt-2 w-1/2"
                  v-model="buttonUrl"
                ></el-input>
                <div class="w-1/2 pl-4 flex items-center cursor-pointer">
                  <feather-icon icon="XIcon" class="flex" />
                </div>
              </div>
            </div>

            <!-- <div  class="mt-6" v-if="value1 == 'Interactive'">
              <h6 class="col-4f text-xl mb-0">Interactive Button Title *</h6>
              <el-input
                placeholder="Enter..."
                class="mt-2 w-full"
                v-model="buttonTitle"
              ></el-input>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ templateName === "" ? "This Field is required" : "" }}
              </p>
            </div> -->

            <!-- <div class="mt-6" v-if="value1 == 'Interactive'">
              <h6 class="col-4f text-xl mb-0">Interactive URL *</h6>
              <el-input
                placeholder="Enter..."
                class="mt-2 w-full"
                v-model="buttonUrl"
              ></el-input>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ templateName === "" ? "This Field is required" : "" }}
              </p>
            </div> -->

            <!-- <div class="mt-6" v-if="value1 == 'Interactive'">
              <h6 class="col-4f text-lg mb-0">Header Text</h6>
              <vue-editor
                id="body2"
                class="quill-height1"
                v-model="headerBody"
              />
            </div> -->
            <div class="mt-8 px-2" v-if="value1 == 'Variable'">
              <div class="mt-2">
                <h6 class="col-4f text-md mb-0">Header *</h6>
                <el-input
                  placeholder="Enter..."
                  class="mt-2 w-full elselect-border0"
                  v-model="variable"
                ></el-input>
              </div>
              <div v-if="count == true" class="flex gap-4">
                <div class="mt-4 w-3/12">
                  <h6 class="col-4f text-md mb-0">Variable*</h6>
                  <el-input
                    disabled
                    placeholder="Enter..."
                    class="mt-2 w-full elselect-border0"
                    v-model="variableHeader"
                  ></el-input>
                </div>
                <div class="mt-4 w-9/12">
                  <h6 class="col-4f text-md mb-0">Variable Value*</h6>
                  <el-input
                    placeholder="Enter..."
                    class="mt-2 w-full elselect-border0"
                    v-model="variableHeaderValue"
                  ></el-input>
                  <p
                    class="text-ff3131 fsize9 my-0"
                    v-if="submitted && !variableHeaderValue"
                  >
                    This Field is Required
                  </p>
                </div>
              </div>
              <div
                class="flex variablebtn justify-start text-primary cursor-pointer fsize12 font-semibold mt-2"
                v-if="!count"
                @click="AddHeaderVariable()"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-1 flex"
                  svgClasses="w-5 h-5"
                />
                <p>Add Variable</p>
              </div>
              <div class="mb-4 mt-2">
                <div>
                  <h6 class="col-4f text-md mb-0">Message Body *</h6>

                  <textarea
                    class="quill-height border-dd p-2 w-textare rounded-lg mt-2 hide-elheader"
                    v-model="variableSmsBody"
                    rows="4"
                    cols="45"
                    type="textarea"
                  ></textarea>
                </div>

                <div
                  class="flex gap-4"
                  v-for="(variable, index) in variables"
                  :key="index"
                >
                  <div class="mt-4 w-3/12">
                    <h6 class="col-4f text-md mb-0">Variable*</h6>
                    <el-input
                      disabled
                      placeholder="Enter..."
                      class="mt-2 w-full elselect-border0"
                      v-model="variable.varRef"
                    ></el-input>
                  </div>
                  <div class="mt-4 w-9/12">
                    <h6 class="col-4f text-md mb-0">Variable Value*</h6>
                    <el-input
                      placeholder="Enter..."
                      class="mt-2 w-full elselect-border0"
                      v-model="variable.varValue"
                    ></el-input>
                    <p
                      class="text-ff3131 fsize9 my-0"
                      v-if="submitted && !variable.varValue"
                    >
                      This Field is Required
                    </p>
                  </div>
                  <!-- <div>
                    <p
                      @click="removeVariableContents(index)"
                      v-if="variables.length > 0"
                      class="text-primary mt-2 cursor-pointer fsize14 font-semibold underline flex justify-end"
                    >
                      Delete
                    </p>
                  </div> -->
                </div>
              </div>
              <div
                @click="handleVariableContents()"
                class="flex variablebtn justify-start text-primary cursor-pointer fsize12 font-semibold mt-2"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-1 flex"
                  svgClasses="w-5 h-5"
                />
                <p>Add Variable</p>
              </div>
            </div>
            <div v-if="value1 !== 'Variable'" class="mt-6">
              <h6 class="col-4f text-lg mb-0">Body Text *</h6>
              <p class="pt-2 text-gray">
                Enter the text for you message in the language you have
                selected.
              </p>
              <textarea
                class="quill-height border-dd p-2 w-textare rounded-lg mt-2 hide-elheader"
                v-model="smsbody"
                rows="4"
                cols="45"
                type="textarea"
              ></textarea>
              <!-- <vue-editor
                id="body1"
                class="quill-height mt-2"
                v-model="smsbody"
              /> -->

              <!-- <textarea v-model="smsbody" rows="3"></textarea
                  >-->
            </div>
          </div>
          <p v-if="submitted == true" class="fsize12 text-danger">
            {{ smsbody.length <= 11 ? "This Field is required" : "" }}
          </p>

          <div v-if="isshowform">
            <div class="mt-6" v-if="value1 == 'Interactive'">
              <h6 class="col-4f text-lg mb-0">Header Text *</h6>
              <vue-editor
                id="body2"
                class="quill-height"
                v-model="headerBody"
              />
            </div>
            <div class="mt-6" v-if="value1 == 'Interactive'">
              <h6 class="col-4f text-lg mb-0">Footer Text *</h6>
              <vue-editor
                id="body3"
                class="quill-height"
                v-model="footerBody"
              />
            </div>
            <h6 v-if="value1 != 'Interactive'" class="col-4f text-xl mb-0">
              Add media *
            </h6>

            <div
              v-if="value1 != 'Interactive'"
              class="bg-aeaeae rounded-12px mt-6 p-5 flex items-center"
            >
              <feather-icon
                icon="UploadIcon"
                svgClasses="w- h-6"
                class="text-white"
              />
              <p class="text-white fsize12 mb-0 pl-2">
                Upload an image in png,jpeg or jpg format.
              </p>
              <input
                type="file"
                class="opacity-0 absolute w-full h-full"
                @change="uploadImage1"
              />
            </div>

            <div
              v-if="value1 != 'Interactive'"
              class="mt-8 p-5 bg-fff7da rounded-10px"
            >
              <p class="fsize12">
                Note:Following are the file formats and their respective sizes
                which are accepted for upload
              </p>

              <div class="mt-2">
                <p class="fsize12 mb-0 pb-1">
                  1. Image:JPEG and PNG (Max size 2MB)
                </p>

                <p class="fsize12 mb-0 pb-1">2. Video:MP4 (Max size 20MB)</p>
                <p class="fsize12 mb-0">3. Document:PDF (Max size 2MB)</p>
              </div>
            </div>
          </div>

          <div class="flex gap-2 justify-center mt-4 bfix">
            <p
              @click="isshowform = false"
              :class="[
                isshowform
                  ? 'bg-gray text-primary '
                  : 'bg-primary text-primary',
              ]"
              class="w-3 h-3 block cursor-pointer rounded-full"
            ></p>
            <p
              v-if="value1 != 'Text' && value1 != 'Variable'"
              @click="handleisshowform()"
              :class="[
                isshowform
                  ? 'bg-primary text-primary '
                  : ' bg-gray text-primary ',
              ]"
              class="w-3 h-3 block bg-gray rounded-full cursor-pointer"
            ></p>
            <!-- <p
              v-if="value1 != 'Text' && value1 != 'Interactive'"
              @click="handleisshowform()"
              :class="[
                isshowform
                  ? 'bg-primary text-primary '
                  : ' bg-gray text-primary ',
              ]"
              class="w-3 h-3 block bg-gray rounded-full cursor-pointer"
            ></p> -->
          </div>

          <div class="absolute bottom-0 margin-niche right-0">
            <div class="cursor-pointer">
              <!-- <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class=""
                @click="handleClick('marcom-Whatsappcampaign-complete')"
              /> -->
              <div v-if="!isshowform" class="bg-primary w-24 h-24 rounded-full">
                <div
                  @click="handleisshowform()"
                  class="flex justify-center items-center w-24 h-24"
                >
                  <feather-icon
                    icon="ArrowRightIcon"
                    svgClasses="w-10 h-10"
                    class="text-white flex"
                  />
                </div>
              </div>
              <div v-if="isshowform" class="bg-primary w-24 h-24 rounded-full">
                <div
                  class="flex justify-center items-center w-24 h-24"
                  @click="handleSubmit()"
                >
                  <feather-icon
                    icon="ArrowRightIcon"
                    svgClasses="w-10 h-10"
                    class="text-white flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
  </div> -->
</template>
<script>
import { mapState } from "vuex";
import { VueEditor } from "vue2-quill-editor";
import moment from "moment";
import Table from "@/views/adminPanel/pages/variables/components/Table.vue";

export default {
  components: {
    Table,
  },
  data() {
    return {
      dialogVisible: false,
      textarea: "",
      messageTitle: "",
      media: "",
      buttonselect: "None",
      variables: [],
      templateTypeOptions: [
        {
          text: "English",
        },
        {
          text: "Hindi",
        },
        {
          text: "Marathi",
        },
      ],
      MediaTypeOptions: [
        {
          value: "Text",
        },
        {
          value: "Image",
        },
        {
          value: "Video",
        },
        {
          value: "File",
        },
        {
          value: "Interactive",
        },
        {
          value: "Variable",
        },
      ],
      index: 1,
      count: false,
      selecttypeOptions: [
        // {
        //   label: "URL",
        //   value: "URL",
        // },
        // {
        //   label: "Phone",
        //   value: "Phone",
        // },
      ],
      buttonOptions: [
        {
          value: "None",
        },
        {
          value: "Call to action",
        },
        {
          value: "Quick reply",
        },
      ],
      buttonOptionsArray: [
        {
          typeValue: "",
          buttonTitle: "",
          buttonValue: "",
        },
      ],
      variable: "",
      variableCount: 0,
      variableHeader: "",
      variableHeaderValue: "",
      buttonTitle: "",
      buttonUrl: "",
      typeValue: "",
      headerBody: "Marketing Stragegy",
      footerBody: "Lets Get Started",
      submitted: false,
      image1: "",
      image1Change: false,
      image1Source: "",
      templateName: "",
      templateType: "",
      templateTitle: "",
      bodyText: "",
      isshowform: false,
      smsbody:
        "You can use dynamic tags to fetch info like names,companies & contact info.",
      variableSmsBody: "",
      value: "",
      value1: "Text",
      URL: "",
      radio: "1",
      addCount: 1,
      removeCount: 1,
      variableNos: [],
      defaultPreviewStructure: "",
      headerDefaultPreviewStructure: "",
    };
  },
  components: {
    VueEditor,
  },

  methods: {
    formattedText(text) {
      return text.replaceAll("\n", "<br />");
    },
    AddHeaderVariable() {
      this.count = true;
      this.variableHeader = "{{1}}";
      this.variable =
        this.variable == ""
          ? this.variable + "{{1}}"
          : this.variable + " " + "{{1}}";
      this.previewHeaderUpdate();
      // this.headerDefaultPreviewStructure = this.variable;
    },
    handleVariableContents() {
      this.variableCount = this.variableCount + 1;
      this.variables.push({
        varRef: `{{${this.variableCount}}}`,
        varValue: "",
      });
      this.variableSmsBody = this.variableSmsBody + `{{${this.variableCount}}}`;
      this.previewBodyUpdate();
      this.variableNos.push(`{{${this.variableCount}}}`);
    },
    removeVariableContents(index) {
      this.variableCount = this.variableCount - 1;
      this.variableSmsBody = this.variableSmsBody
        .replace(`${this.variables[index].varRef}`, "")
        .trim();
      // this.defaultPreviewStructure = this.variableSmsBody;

      this.variables.pop(index, 1);
    },
    addCountVerf() {
      if (this.addCount < 2) {
        return true;
      } else {
        return false;
      }
    },
    removeCountVerf() {
      if (this.removeCount > 1) {
        return true;
      } else {
        return false;
      }
    },
    remove() {
      this.buttonOptionsArray.pop();
      this.removeCount = this.removeCount - 1;
      this.addCount = this.addCount - 1;
      this.selecttypeOptions = [
        {
          label: "URL",
          value: "URL",
        },
        {
          label: "Phone",
          value: "Phone",
        },
      ];
    },
    add() {
      if (
        this.buttonOptionsArray[0].typeValue &&
        this.buttonOptionsArray[0].buttonTitle &&
        this.buttonOptionsArray[0].buttonValue
      ) {
        this.addCount = this.addCount + 1;
        this.removeCount = this.removeCount + 1;
        this.buttonOptionsArray.push({
          typeValue: "",
          buttonTitle: "",
          buttonValue: "",
        });
        if (this.buttonOptionsArray[0].typeValue == "URL") {
          this.selecttypeOptions = [
            {
              label: "Phone",
              value: "Phone",
            },
          ];
        } else {
          this.selecttypeOptions = [
            {
              label: "URL",
              value: "URL",
            },
          ];
        }
      } else {
        this.$swal({
          text: "Please fill all the required Fields",
          icon: "warning",

          confirmButtonColor: "#830c81",
          // cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        });
      }
    },
    link() {
      windows.open(this.URL, "_blank");
    },
    // handleClick(name) {
    //   this.$router.push({ name: name });
    // },

    handleisshowform() {
      if (this.value1 == "Variable") {
        this.submitted = true;
        let status = [];
        for (let i = 0; i < this.variables.length; i++) {
          if (this.variables[i].varValue == "") {
            status.push(true);
          } else {
            status.push(false);
          }
        }
        if (this.variable.includes("{{1}}") && this.variableHeader == "") {
          status.push(true);
        }
        if (
          this.templateName !== "" &&
          this.value !== "" &&
          this.value1 &&
          this.variable &&
          !status.includes(true) &&
          this.variableSmsBody
        ) {
          this.handleSubmit();
        } else {
          this.$swal({
            text: "Please fill all the required Fields",
            icon: "warning",

            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
        }
      } else if (this.value1 == "Text") {
        if (
          this.templateName !== "" &&
          this.value !== "" &&
          this.smsbody !== "" &&
          this.value1
        ) {
          this.handleSubmit();
        } else {
          this.$swal({
            text: "Please fill all the required Fields",
            icon: "warning",

            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
        }
      } else if (
        this.value1 != "Interactive" &&
        this.value1 != "Text" &&
        this.value1 != "Variable"
      ) {
        if (
          this.templateName !== "" &&
          this.value !== "" &&
          this.smsbody !== "" &&
          this.value1
        ) {
          this.submitted = true;
          this.isshowform = true;
        } else {
          this.$swal({
            text: "Please fill all the required Fields",
            icon: "warning",

            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
        }
      } else if (
        this.value1 == "Interactive" &&
        this.buttonselect == "Call to action"
      ) {
        if (
          this.templateName !== "" &&
          this.value !== "" &&
          this.smsbody !== "" &&
          this.value1 &&
          this.buttonOptionsArray[0].typeValue &&
          this.buttonOptionsArray[0].buttonTitle &&
          this.buttonOptionsArray[0].buttonValue
        ) {
          this.submitted = true;
          this.isshowform = true;
        } else {
          this.$swal({
            text: "Please fill all the required Fields",
            icon: "warning",

            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
        }
      }
    },
    async uploadImage1(e) {
      this.image1Change = true;
      this.image1 = e.target.files[0];

      const reader = new FileReader();
      this.image1Source = await this.convertToBase64(e.target.files[0]);
      // console.log(this.image1Source);
    },
    previewBodyUpdate() {
      this.defaultPreviewStructure = this.variableSmsBody;
      for (let i = 0; i < this.variables.length; i++) {
        this.defaultPreviewStructure = this.defaultPreviewStructure.replaceAll(
          this.variables[i].varRef,
          this.variables[i].varValue
        );
      }
    },
    previewHeaderUpdate() {
      console.log("reached");
      this.headerDefaultPreviewStructure = this.variable;
      this.headerDefaultPreviewStructure =
        this.headerDefaultPreviewStructure.replaceAll(
          "{{1}}",
          this.variableHeaderValue
        );
      // this.variable = this.headerDefaultPreviewStructure
    },
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.templateName = this.templateName
          ? this.templateName.trimStart()
          : "";
      });
    },
    convertToBase64(file) {
      return new Promise(async (resolve, reject) => {
        let reader = new FileReader();
        await reader.readAsDataURL(file);

        reader.onloadend = await function () {
          resolve(reader.result);
        };
      });
    },
    async handleSubmit() {
      try {
        let payload;
        let format = this.smsbody;
        if (this.value1 == "Variable") {
          payload = {
            projectId: this.selectedProject._id,
            projectName: this.selectedProject.projectName,
            displayName: this.selectedProject.displayName,
            label: this.templateName,
            language: this.value,
            format: this.variableSmsBody,
            mediaType: this.value1.toLowerCase(),
            user: this.taskListUsers.PM[0]._id,
          };
          if (!this.variable.includes("{{1}}")) {
            Object.assign(payload, { variable: this.variable });
          } else {
            Object.assign(payload, {
              headerVariable: {
                variableHeader: this.variable,
                // variableHeader: this.variableHeader,
                variableHeaderValue: this.variableHeaderValue,
              },
            });
          }
          // Object.assign(payload, { variableSmsBody: this.variableSmsBody });
          if (this.variableSmsBody.includes("{{1}}")) {
            // console.log(this.variables);
            Object.assign(payload, { variables: this.variables });
          }
          if (
            this.variable.includes("{{1}}") ||
            this.variableSmsBody.includes("{{1}}")
          ) {
            Object.assign(payload, { variableType: true });
          }

          let data = await this.$store.dispatch(
            "whatsApp/createTemplate",
            payload
          );

          if (data.code == 200) {
            this.$swal({
              text: "Created Successfully",
              icon: "success",

              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Okay",
            });
            let data = "Whats App";
            this.$store.commit("template/TEMPLATE_VALUE_STORE", data);
            this.$router.push({ name: "marcom-Templates" });
          }
        } else if (this.value1 == "Text") {
          payload = {
            projectId: this.selectedProject._id,
            projectName: this.selectedProject.projectName,
            displayName: this.selectedProject.displayName,
            label: this.templateName,
            language: this.value,
            format: this.smsbody,
            mediaType: this.value1.toLowerCase(),
            user: this.taskListUsers.PM[0]._id,
          };

          let data = await this.$store.dispatch(
            "whatsApp/createTemplate",
            payload
          );

          if (data.code == 200) {
            this.$swal({
              text: "Created Successfully",
              icon: "success",

              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Okay",
            });
            let data = "Whats App";
            this.$store.commit("template/TEMPLATE_VALUE_STORE", data);
            this.$router.push({ name: "marcom-Templates" });
          }
        } else if (this.value1 == "Interactive") {
          if (
            this.templateName !== "" &&
            this.value !== "" &&
            this.smsbody !== "" &&
            this.value1 !== "" &&
            this.buttonOptionsArray[0].buttonTitle !== "" &&
            this.buttonOptionsArray[0].buttonValue !== "" &&
            this.headerBody !== "" &&
            this.footerBody !== ""
          ) {
            let body;
            if (this.buttonOptionsArray[1]) {
              body = `${this.headerBody} \n\n ${this.smsbody} \n ${this.footerBody} | [${this.buttonOptionsArray[0].buttonTitle},${this.buttonOptionsArray[0].buttonValue}] | [${this.buttonOptionsArray[1].buttonTitle},${this.buttonOptionsArray[1].buttonValue}]`;
            } else {
              body = `${this.headerBody} \n\n ${this.smsbody} \n ${this.footerBody} | [${this.buttonOptionsArray[0].buttonTitle},${this.buttonOptionsArray[0].buttonValue}]`;
            }
            payload = {
              projectId: this.selectedProject._id,
              projectName: this.selectedProject.projectName,
              displayName: this.selectedProject.displayName,
              label: this.templateName,
              language: this.value,
              format: body,
              buttonTitle: this.buttonOptionsArray[0].buttonTitle,
              buttonUrl: this.buttonOptionsArray[0].buttonValue,
              mediaType: this.value1.toLowerCase(),
              user: this.taskListUsers.PM[0]._id,
            };
            if (
              this.buttonOptionsArray[1] &&
              this.buttonOptionsArray[1].buttonTitle
            ) {
              Object.assign(payload, {
                buttonTitle1: this.buttonOptionsArray[1].buttonTitle,
                buttonUrl1: this.buttonOptionsArray[1].buttonValue,
              });
            }
            let data = await this.$store.dispatch(
              "whatsApp/createTemplate",
              payload
            );

            if (data.code == 200) {
              this.$swal({
                text: "Created Successfully",
                icon: "success",

                confirmButtonColor: "#830c81",
                // cancelButtonColor: "#d33",
                confirmButtonText: "Okay",
              });
              let Data = "Whats App";
              this.$store.commit("template/TEMPLATE_VALUE_STORE", Data);
              this.$router.push({ name: "marcom-Templates" });
            }
          } else {
            this.$swal({
              text: "Please Upload Respective Media",
              icon: "warning",

              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Okay",
            });
          }

          // console.log(data);
        } else {
          if (this.isshowform == true && this.image1) {
            payload = new FormData();

            payload.append("projectId", this.selectedProject._id);
            payload.append("projectName", this.selectedProject.projectName);
            payload.append("displayName", this.selectedProject.displayName);
            payload.append("label", this.templateName);
            payload.append("language", this.value);
            payload.append("format", this.smsbody);
            payload.append("user", this.taskListUsers.PM[0]._id);
            payload.append("mediaType", this.value1.toLowerCase());
            payload.append("media", this.image1);
            let data = await this.$store.dispatch(
              "whatsApp/createTemplate",
              payload
            );

            if (data.code == 200) {
              this.$swal({
                text: "Created Successfully",
                icon: "success",

                confirmButtonColor: "#830c81",
                // cancelButtonColor: "#d33",
                confirmButtonText: "Okay",
              });
              let data = "Whats App";
              this.$store.commit("template/TEMPLATE_VALUE_STORE", data);
              this.$router.push({ name: "marcom-Templates" });
            }
          } else {
            this.$swal({
              text: "Please Upload Respective Media",
              icon: "warning",

              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Okay",
            });
          }

          console.log(data);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    templateName() {
      this.whitespaceRemove();
    },
    buttonselect(val) {
      if (val == "Call to action") {
        this.selecttypeOptions = [
          {
            label: "URL",
            value: "URL",
          },
          {
            label: "Phone",
            value: "Phone",
          },
        ];
      }
    },
    variableSmsBody(val) {
      if (this.variableSmsBody == "") {
        this.defaultPreviewStructure = "";
      }
      if (val && this.value1 == "Variable") {
        let test = this.variableSmsBody.match(/{{(\d+)}}/g);
        if (test != null) {
          for (let index = 0; index < test.length; index++) {
            if (!this.variableNos.includes(test[index])) {
              this.variableNos.push(test[index]);
              this.variableCount = this.variableCount + 1;
              this.variables.push({
                varRef: test[index],
                varValue: "",
              });
            }
          }
          for (let index = 0; index < this.variableNos.length; index++) {
            if (!test.includes(this.variableNos[index])) {
              this.variableNos.pop(this.variableNos[index], 1);
              this.variableCount = this.variableCount - 1;
              for (let j = 0; j < this.variables.length; j++) {
                if (!this.variableNos.includes(this.variables[j].varRef)) {
                  this.variables.pop(j, 1);
                }
              }
            }
          }
          this.previewBodyUpdate();
          // this.defaultPreviewStructure = this.variableSmsBody;
        } else {
          this.variableNos = [];
          this.variableCount = 0;
          this.variables = [];
          // this.defaultPreviewStructure = this.variableSmsBody;
        }
      }
    },
    variable(val) {
      if (val == "") {
        this.headerDefaultPreviewStructure = "";
      }
      if (val.includes("{{1}}")) {
        if (this.count == false) {
          this.count = true;
          this.variableHeader = "{{1}}";
          // this.previewHeaderUpdate();
          this.headerDefaultPreviewStructure = this.variable;
        }
      } else {
        this.count = false;
        this.variableHeader = "";
        this.variableHeaderValue = "";
        this.previewHeaderUpdate();
      }
    },
    variableHeaderValue(val) {
      if (val) {
        this.previewHeaderUpdate();
      }
    },
    variables: {
      handler: function (val) {
        if (val) {
          this.previewBodyUpdate();
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("marcom", ["taskListUsers"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("template", ["valueTemplate"]),
    dateFormat() {
      return moment().format("ddd, MMMM DD");
    },
    timeFormat() {
      return moment().format("HH:mm a");
    },
  },
};
</script>
